export class IndicatorAlertSettings {
    constructor(
        public readonly enableInApp: boolean,
        public readonly enableEmail: boolean,
        public readonly alertDue7d: boolean,
        public readonly alertDue1d: boolean,
        public readonly alertDueToday: boolean,
        public readonly alertOverdue: boolean,
    ) {}

    static defaults(): IndicatorAlertSettings {
        return new IndicatorAlertSettings(true, true, true, true, true, true);
    }

    with(values: Partial<IndicatorAlertSettings>): IndicatorAlertSettings {
        return new IndicatorAlertSettings(
            values.enableInApp ?? this.enableInApp,
            values.enableEmail ?? this.enableEmail,
            values.alertDue7d ?? this.alertDue7d,
            values.alertDue1d ?? this.alertDue1d,
            values.alertDueToday ?? this.alertDueToday,
            values.alertOverdue ?? this.alertOverdue,
        );
    }
}
